export default {
  common: {
    view: 'View',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    reset: 'Remove',
    edit: 'Edit',
    create: 'Create',
    close: 'Close',
    next: 'Next',
    back: 'Back',
    search: 'Search',
    upload: 'Upload',
    download: 'Download',
    downloadAll: 'Download all',
    confirm: 'Confirm',
    all: 'All',
    loading: 'Loading...',
    noData: 'No data found',
    error: 'Error',
    success: 'Success',
  },

  layout: {
    savat: 'Trash',
    dv: "Green Card (DV)",
    brand: 'Oasis Visa CRM',
    dashboard: 'Dashboard',
    tasks: 'Tasks',
    clients: 'Clients',
    tekshiruv: 'Review',
    vacancies: 'Vacancies',
    partners: 'Partners',
    employees: 'Employees',
    monitoring: 'Monitoring',
    settings: 'Settings',
    profile: 'Profile',
    logout: 'Logout',
    logoutSuccess: 'You have been logged out',
    newClient: 'New client',
    botSurveys: 'Bot Surveys',
    cvBuilder: 'CV Builder',
    emailMarketing: 'Email Marketing',
    scrapedJobs: 'Job Listings',
    calendar: 'Calendar',
    notifications: 'Notifications',
    admin: 'Administrator',
    employee: 'Employee',
    expand: 'Expand',
    collapse: 'Collapse',
  },

  notifications: {
    title: 'Notifications',
    all: 'All',
    unread: 'Unread',
    tasks: 'Tasks',
    system: 'System',
    markAllRead: 'Mark all as read',
    cleanOld: 'Clean old',
    viewAll: 'View all',
    telegramUlash: 'Connect Telegram',
    telegramUlangan: 'Telegram connected',
    telegramUzish: 'Click to disconnect Telegram',
    telegramYoriqnoma: 'Open the bot in Telegram and press «Start» — the link is valid for {n} min',
    telegramXato: 'Telegram could not be connected — try again later',
    noNotifications: 'No notifications',
    noUnread: 'No unread notifications',
    markAsRead: 'Mark as read',
    deleteNotif: 'Delete',
    now: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    daysAgo: '{n} d ago',
    markAllSuccess: 'All notifications marked as read',
    errorGeneric: 'An error occurred',
    confirmClean: 'Read notifications older than 30 days will be deleted. Continue?',
    confirmCleanTitle: 'Confirm',
    yesDelete: 'Yes, delete',
    cancelBtn: 'Cancel',
    typeTask: 'Task',
    typeCompleted: 'Completed',
    typeApproved: 'Approved',
    typeOverdue: 'Overdue',
    typeComment: 'Comment',
    typeClient: 'Client',
    typeSystem: 'System',
    typeReminder: 'Reminder',
    newVacancy: 'New vacancy at company!',
    taskCompleted: 'Task completed',
    taskAssigned: 'Task assigned',
    taskReviewed: 'Task reviewed',
    callbackInMinutes: 'Callback (in {n} min)',
    callbackOn: 'Callback: {name}',
    taskDoneBy: 'Task "{task}" was completed by {user}',
    callNoAnswer: 'No answer',
    callCallback: 'Callback',
    callAnswered: 'Answered',
    callBusy: 'Busy',
    callSuccess: 'Successful',
    callRejected: 'Rejected',
  },

  calendar: {
    today: 'Today',
    allStatuses: 'All statuses',
    allPriorities: 'All priorities',
    more: 'more',
    noEvents: 'No events',
    tasks: 'tasks',
    startDate: 'Start',
    dueDate: 'Due date',
    dueTime: 'Time',
    assignee: 'Assignee',
    description: 'Description',
    goToTask: 'Go to task',
    viewMonth: 'Month',
    viewWeek: 'Week',
    viewList: 'List',
    statusNew: 'New',
    statusInProgress: 'In progress',
    statusCompleted: 'Completed',
    statusApproved: 'Approved',
    prioLow: 'Low',
    prioMedium: 'Medium',
    prioHigh: 'High',
    prioUrgent: 'Urgent',
    dayMon: 'Mo', dayTue: 'Tu', dayWed: 'We', dayThu: 'Th', dayFri: 'Fr', daySat: 'Sa', daySun: 'Su',
    shortSun: 'Sun', shortMon: 'Mon', shortTue: 'Tue', shortWed: 'Wed', shortThu: 'Thu', shortFri: 'Fri', shortSat: 'Sat',
    monthShortJan: 'Jan', monthShortFeb: 'Feb', monthShortMar: 'Mar', monthShortApr: 'Apr',
    monthShortMay: 'May', monthShortJun: 'Jun', monthShortJul: 'Jul', monthShortAug: 'Aug',
    monthShortSep: 'Sep', monthShortOct: 'Oct', monthShortNov: 'Nov', monthShortDec: 'Dec',
    monthJan: 'January', monthFeb: 'February', monthMar: 'March', monthApr: 'April',
    monthMay: 'May', monthJun: 'June', monthJul: 'July', monthAug: 'August',
    monthSep: 'September', monthOct: 'October', monthNov: 'November', monthDec: 'December',
    addEvent: 'Add event',
    eventName: 'Name',
    eventNamePh: 'Event name',
    dateLabel: 'Date',
    timeLabel: 'Time',
    priorityLabel: 'Priority',
    visibility: 'Visibility',
    onlyMe: 'Only me',
    everyone: 'Everyone',
    selectEmployee: 'Select employee',
    noteLabel: 'Note',
    notePh: 'Additional note...',
    cancel: 'Cancel',
    save: 'Save',
    eventSaved: 'Event saved!',
    eventDeleted: 'Event deleted',
    errorGeneric: 'An error occurred',
    confirmDeleteTitle: 'Delete',
    confirmDeleteMsg: 'Delete event "{title}"?',
    yes: 'Yes',
    createdBy: 'Created by',
    adminBadge: 'Manager',
    goToVacancy: 'Go to vacancy',
    deleteBtn: 'Delete',
  },

  login: {
    title: 'AgentsVA CRM',
    subtitle: 'Sign in',
    username: 'Username',
    password: 'Password',
    loginButton: 'Sign in',
    loggingIn: 'Signing in...',
    welcome: 'Welcome!',
    invalidCredentials: 'Invalid username or password',
    usernameRequired: 'Please enter username',
    passwordRequired: 'Please enter password',
  },

  dashboard: {
    totalTasks: 'Total tasks',
    approved: 'Approved',
    inProgress: 'In progress',
    totalClients: 'Total clients',
    recentTasks: 'Recent tasks',
    recentClients: 'Recent clients',
    task: 'Task',
    status: 'Status',
    firstName: 'First name',
    lastName: 'Last name',
    country: 'Country',
    viewAll: 'View all',
    loadError: 'Error loading data',
    quickActions: 'Quick Actions',
    addClient: 'New Client',
    viewVacancies: 'Vacancies',
    cvBuilder: 'Build CV',
    botSurveys: 'Bot Surveys',
    noTasks: 'No tasks yet',
    noClients: 'No clients yet',
    statTasks: 'Tasks',
    statNew: 'New',
    statInProgress: 'In progress',
    statApproved: 'Approved',
    statClients: 'Clients',
    statVacancies: 'Vacancies',
    statMyPartners: 'My partners',
    statMyClients: 'My clients',
    allLink: 'View all',
    greetingNight: 'Good night',
    greetingMorning: 'Good morning',
    greetingDay: 'Good afternoon',
    greetingEvening: 'Good evening',
    monthJan: 'January', monthFeb: 'February', monthMar: 'March', monthApr: 'April',
    monthMay: 'May', monthJun: 'June', monthJul: 'July', monthAug: 'August',
    monthSep: 'September', monthOct: 'October', monthNov: 'November', monthDec: 'December',
    daySun: 'Sunday', dayMon: 'Monday', dayTue: 'Tuesday', dayWed: 'Wednesday',
    dayThu: 'Thursday', dayFri: 'Friday', daySat: 'Saturday',
    cStatusYangi: 'New',
    cStatusHujjat: 'Documents',
    cStatusTayyor: 'Ready',
    cStatusKutilmoqda: 'Pending',
    cStatusVizaOldi: 'Visa received',
    cStatusJonatildi: 'Dispatched',
    cStatusBekor: 'Cancelled',
  },

  chat: {
    title: 'Chat',
    searchPlaceholder: 'Search...',
    searchChat: 'Search chats...',
    newChat: 'New chat',
    newGroup: 'New group',
    myChats: 'My chats',
    allChats: 'All',
    noChats: 'No chats',
    noMessages: 'No messages',
    typeMessage: 'Type a message...',
    send: 'Send',
    attach: 'Attach file',
    emoji: 'Emoji',
    mention: 'Mention',
    share: 'Share',
    shareVacancy: 'Share vacancy',
    shareClient: 'Share client',
    selectMember: 'Select member',
    addMember: 'Add member',
    removeMember: 'Remove member',
    leaveGroup: 'Leave group',
    deleteChat: 'Delete chat',
    chatName: 'Chat name',
    groupName: 'Group name',
    members: 'Members',
    membersCount: '{count} members',
    online: 'Online',
    offline: 'Offline',
    typing: 'Typing...',
    edit: 'Edit',
    delete: 'Delete',
    reply: 'Reply',
    copy: 'Copy',
    forward: 'Forward',
    messageDeleted: 'Message deleted',
    messageEdited: 'edited',
    confirmDeleteMsg: 'Delete this message?',
    confirmDeleteChat: 'Delete this chat?',
    confirmLeaveGroup: 'Leave this group?',
    chatCreated: 'Chat created',
    createError: 'Failed to create chat',
    sendError: 'Failed to send message',
    fileTooLarge: 'File too large (max 25MB)',
    fileUploadError: 'Failed to upload file',
    searchUser: 'Search user...',
    select: 'Select',
    createChat: 'Create chat',
    create: 'Create',
    cancel: 'Cancel',
    confirm: 'Confirm',
    today: 'Today',
    yesterday: 'Yesterday',
    selectChat: 'Select a chat',
    selectChatHint: 'Choose a chat from the left to start messaging',
    groupInfo: 'Group info',
    privateChat: 'Direct chat',
    groupChat: 'Group chat',
    me: 'Me',
    you: 'You',
    unreadMessages: 'unread messages',
    replyTo: 'Reply',
    writeMessage: 'Type a message...',
    uploadImage: 'Upload image',
    uploadFile: 'Upload file',
    sharedVacancy: 'Shared vacancy',
    sharedClient: 'Shared client',
    viewDetails: 'View details',
    addEmoji: 'Add emoji',
    loadingMessages: 'Loading messages...',
    loadMore: 'Load more',
    photo: 'Photo',
    file: 'File',
    noResults: 'No results',
    groupsSection: 'Groups',
    privateSection: 'Private chats',
    messagesShort: 'msg',
    emptyShort: 'empty',
    settings: 'Settings',
    retry: 'Retry',
    attachImageFile: 'Image/file',
    vacancyKind: 'Vacancy',
    clientKind: 'Client',
    searchVacancyPlaceholder: 'Search vacancy...',
    searchClientPlaceholder: 'Client name...',
    enterSearchHint: 'Enter search term',
    addMemberPh: 'Add member...',
    addBtn: 'Add',
    removeBtn: 'Remove',
    adminTag: 'Admin',
    saveBtn: 'Save',
    clearMessages: 'Clear messages',
    deleteAllMessages: 'Delete all messages',
    dangerZone: 'Danger zone',
    deleteChatCompletely: 'Delete chat completely',
    adminCleanup: 'Admin: Cleanup old messages',
    olderThan: 'Older than {n} days',
    deleteAllNow: 'Delete all now',
    editMessage: 'Edit message',
  },

  partners: {
    title: 'Partners',
    total: 'Total',
    statusNew: 'New',
    statusRegular: 'Regular',
    statusPremium: 'Premium',
    statusVip: 'VIP',
    dirWork: 'Work',
    dirStudy: 'Education',
    dirTravel: 'Travel',
    dirAvia: 'Aviation',
    filterAll: 'All',
    filterDir: 'Direction',
    filterCountry: 'Country',
    filterStatusLabel: 'Status',
    filterCategory: 'Category',
    filterEmployee: 'Employee',
    partnerStatusTitle: 'Partnership status',
    trustLevel: 'Trust level',
    category: 'Category',
    employee: 'Employee',
    categoryAgency: 'Agency',
    categoryDirect: 'Direct',
    categoryScammer: 'Scammer',
    categoryUnknown: 'Unknown',
    vacancyLabel: 'Vacancy',
    vacancyName: 'Vacancy title',
    companyName: 'Company',
    dateLabel: 'Date',
    vacancyDescription: 'Additional notes...',
    saveFilter: 'Save filter',
    removeFilter: 'Remove filter',
    addPartner: 'Add partner',
    editPartner: 'Edit partner',
    partnerAddSuccess: 'Partner added',
    partnerAlreadyExists: 'This contact is already in partners list: "{name}"',
    confirmRemove: 'Remove partnership with "{title}"?',
    confirmRemoveTitle: 'Remove partnership',
    yesRemove: 'Yes, remove',
    noCancel: 'No',
    removeSuccess: 'Partnership removed',
    bulkSelected: '{count} selected',
    bulkAssignEmployees: 'Employees',
    bulkNotAssigned: '— Unassigned —',
    bulkAssignBtn: 'Assign',
    bulkAssignSuccess: '{count} partners assigned',
    bulkAssignCancelled: 'Assignment cancelled',
    saved: 'Saved',
    errorGeneric: 'An error occurred',
    totalVacancies: 'Total vacancies',
    activePartners: 'Active partners',
    assigned: 'Assigned',
    newPartner: 'New partner',
    searchPlaceholder: 'Vacancy, company, city...',
    companyName: 'Company name',
    contactPerson: 'Contact person',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    address: 'Address',
    country: 'Country',
    city: 'City',
    jobTitle: 'Vacancy title',
    description: 'Description',
    notes: 'Notes',
    status: 'Status',
    assignedTo: 'Assigned to',
    additionalAssignees: 'Additional employees',
    linkedClients: 'Linked clients',
    linkClient: 'Link client',
    unlinkClient: 'Unlink client',
    selectClients: 'Select clients',
    noLinkedClients: 'No linked clients',
    multiAssignTitle: 'Multi-employee assignment',
    selectAssignees: 'Select employees',
    assignPartner: 'Assign partner',
    assignPartnerHint: 'This vacancy has been assigned to you',
    callPhone: 'Call',
    sendEmail: 'Send email',
    openWebsite: 'Open website',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    confirmDelete: 'Delete this partner?',
    confirmUnlink: 'Unlink this client?',
    deleteSuccess: 'Partner deleted',
    deleteError: 'Failed to delete',
    saveSuccess: 'Saved',
    saveError: 'Failed to save',
    assignSuccess: 'Assigned',
    assignError: 'Failed to assign',
    linkSuccess: 'Client linked',
    unlinkSuccess: 'Client unlinked',
    noPartners: 'No partners',
    loadError: 'Failed to load data',
    openDetails: 'Details',
    close: 'Close',
    postedAt: 'Posted at',
    source: 'Source',
    sourceLink: 'Link',
    category: 'Category',
    myPartners: 'My partners',
    allPartners: 'All partners',
    filterCountry: 'By country',
    filterStatus: 'By status',
    actions: 'Actions',
    viewVacancy: 'View vacancy',
    assigneeLabel: 'Assigned employee',
    additionalLabel: 'Additional employees',
    noAssignee: 'Unassigned',
    selectClientsPlaceholder: 'Search and select clients',
    clientSelected: '{count} clients selected',
    apply: 'Apply',
  },

  status: {
    new: 'New',
    in_progress: 'In progress',
    completed: 'Completed',
    approved: 'Approved',
  },

  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent',
  },

  tasks: {
    title: 'Tasks',
    newTask: 'New task',
    all: 'All',
    new: 'New',
    inProgress: 'In progress',
    completed: 'Completed',
    approved: 'Approved',
    employee: 'Employee',
    statusCol: 'Status',
    priorityCol: 'Priority',
    deadline: 'Deadline',
    actions: 'Actions',
    start: 'Start',
    complete: 'Complete',
    approve: 'Approve',
    taskStarted: 'Task started',
    confirmComplete: 'Mark this task as completed?',
    confirmCompleteTitle: 'Confirm',
    taskCompleted: 'Task completed',
    confirmApprove: 'Approve this task?',
    confirmApproveTitle: 'Confirm',
    taskApproved: 'Task approved',
    noTasks: 'No tasks',
  },

  taskDetail: {
    result: 'Work result',
    noResult: 'No result uploaded',
    addResult: 'File / screenshot',
    resultHint: 'A file or screenshot showing what you did',
    resultUploaded: 'Result uploaded',
    resultPartial: '{n} file(s) failed to upload',
    resultDeleted: 'Result deleted',
    deleteResultConfirm: '{name} will be deleted. Continue?',
    description: 'Description',
    assignedTo: 'Assigned to',
    createdBy: 'Created by',
    startDate: 'Start date',
    dueDate: 'Due date',
    createdAt: 'Created at',
    completedAt: 'Completed at',
    comments: 'Comments',
    noComments: 'No comments',
    addComment: 'Write a comment...',
    send: 'Send',
    commentAdded: 'Comment added',
  },

  taskCreate: {
    title: 'Create new task',
    taskName: 'Task name',
    description: 'Description',
    employee: 'Employee',
    employeePlaceholder: 'Select employee',
    priority: 'Priority',
    startDate: 'Start date',
    dueDate: 'Due date',
    dueTime: 'Due time',
    create: 'Create',
    cancel: 'Cancel',
    taskNameRequired: 'Please enter task name',
    descriptionRequired: 'Please enter description',
    employeeRequired: 'Please select employee',
    startDateRequired: 'Please select start date',
    dueDateRequired: 'Please select due date',
    dueTimeRequired: 'Please select due time',
    createSuccess: 'Task created',
    createError: 'Error creating task',
    loadEmployeesError: 'Error loading employees',
  },

  slot: {
    title: 'Slot',
    ustun: 'Slot',
    yoq: 'No slot yet — when booked, enter it here: date, time and place',
    qosh: 'Add slot',
    qoshYana: 'Add another slot',
    joyYoq: 'Place not set',
    joyMisol: 'E.g. Embassy of Estonia or VFS Global (Tashkent)',
    anketa: 'Application',
    bordi: 'Attended',
    kelmadi: 'No-show',
    kochir: 'Reschedule',
    tahrir: 'Edit',
    bekor: 'Cancel slot',
    yana: 'More actions',
    bekorSavol: 'Cancel this slot? Reminders will stop.',
    tarix: 'Other slots ({n})',
    sana: 'Date',
    soat: 'Time',
    joy: 'Place (embassy / visa centre)',
    manzil: 'Address',
    maqsad: 'Purpose',
    izoh: 'Note',
    saqlandi: 'Slot saved — reminders are sent automatically',
    holatQoyildi: 'Status set',
    xato: 'Not saved',
    shakl: { yangi: 'New slot', tahrir: 'Edit slot', kochir: 'Reschedule — new date' },
    maqsadlar: { topshirish: 'Document submission', biometrika: 'Biometrics', intervyu: 'Interview', olish: 'Passport / visa pickup' },
    qoldi: { otdi: 'Time passed — set the status', bugun: 'Today, {soat}', ertaga: 'Tomorrow, {soat}', kun: '{n} days left' },
  },
  tekshiruv: {
    title: 'Review queue',
    subtitle: 'Values written to client cards automatically from documents that no employee has looked at yet. Compare with the document: confirm if correct, fix it or pick another value from the document if wrong. Only reviewed data should go into applications.',
    kimniki: 'Which clients',
    daraja: 'Confidence',
    mening: 'My clients',
    barcha: 'All clients',
    hammasi: 'All',
    jami: '{n} values · {m} clients',
    bosh: 'Nothing to review — everything has been checked',
    boshMening: 'Nothing to review for your clients',
    masul: 'Owner: {name}',
    hujjat: 'Source document',
    pdfOch: 'Open PDF',
    togri: 'Correct',
    yuqorilar: 'Confirm high ({n})',
    tasdiqlandi: '{n} values confirmed',
    saqlandi: 'Fixed and saved',
    tanlandi: '{field}: value from the document written',
    xato: 'Not saved — please try again',
  },
  savat: {
    title: 'Trash',
    subtitle: 'Deleted clients stay here with their documents, facts and cases. «Restore» brings '
      + 'them back with one click.',
    bosh: 'Trash is empty',
    mijoz: 'Client',
    qachon: 'Deleted at',
    kim: 'Deleted by',
    hujjatlar: 'Documents',
    qaytarish: 'Restore',
    qaytarildi: '{ism} restored',
    faqatAdmin: 'Trash is available to administrators only',
  },
  hujjatSavat: {
    tugma: 'Trash ({n})',
    title: 'Document trash',
    subtitle: 'Deleted documents stay here with their file and extracted data. "Restore" puts a document back. '
      + 'Documents in the trash are hidden from forms, CC and Claude.',
    bosh: 'Trash is empty',
    qachon: 'Deleted',
    kim: 'Deleted by',
    sabab: 'Reason',
    korish: 'Open',
    qaytarish: 'Restore',
    qaytarildi: '{tur} restored',
    butunlay: 'Delete permanently',
    butunlayTasdiq: 'The document and its file will be deleted PERMANENTLY — this cannot be undone. Type "{soz}" to confirm:',
    sozMosEmas: 'Confirmation word does not match',
    ochirildi: 'Document deleted permanently',
  },
  clients: {
    olaman: 'Take it',
    olindi: 'Client assigned to you',
    allaqachonOlingan: 'Another employee has already taken this client: {kim}',
    savatgaTasdiq: 'The client will be moved to Trash and can be restored with one click. To confirm, '
      + 'type the client\'s full name: {ism}',
    savatgaTashlash: 'Move to Trash',
    ismMosEmas: 'Name does not match — type the client\'s first and last name',
    savatgaTushdi: '{ism} moved to Trash — it can be restored from Trash',
    bulkLinkSuccess: '{clients} clients linked to {partners} partners',
    bulkAssignSuccess: '{count} clients assigned',
    bulkAssignCancelled: 'Assignment cancelled',
    bulkNotAssigned: '— Unassigned —',
    employeesLabel: 'Employees',
    assignBtn: 'Assign',
    linkToPartner: 'Link to partner',
    selectedCount: '{count} selected',
    errorGeneric: 'Error occurred',
    title: 'Clients',
    scope: {
      label: 'Which clients',
      all: 'All clients',
      mine: 'My clients',
      mineHint: 'Clients assigned to you — as the main owner or as an additional assignee',
      co: 'co-assigned',
      coHint: 'You are an additional assignee for this client (the main owner is another employee)',
      mineEmpty: 'No clients are assigned to you yet',
    },
    newClient: 'New client',
    searchPlaceholder: 'Name, passport, phone...',
    fullName: 'Full name',
    passport: 'Passport',
    phone: 'Phone',
    country: 'Country',
    travelPurpose: 'Purpose',
    direction: 'Direction',
    status: 'Status',
    employee: 'Employee',
    all: 'All',
    registeredBy: 'Registered by',
    date: 'Date',
    actions: 'Actions',
    view: 'View',
    delete: 'Delete',
    confirmDelete: 'Do you want to delete this client?',
    confirmDeleteTitle: 'Confirm',
    deleteSuccess: 'Client deleted',
    searchError: 'Search error',
    noSearchResults: 'No results found',
    noClients: 'No clients yet',
    uploadPhoto: 'Upload photo (click)',
    photoUploaded: 'Photo uploaded successfully',
    photoUploadError: 'Error uploading photo',
    workInfo: 'Job / University',
    notes: 'Notes',
    addNote: 'Add a note...',
    noteSaved: 'Note saved',
    noteError: 'Error saving note',
    noWorkInfo: '\u2014',
    ov: {
      total: 'Total clients',
      totalSub: '{countries} countries · {directions} directions',
      active: 'In progress',
      activeHint: 'New, collecting documents, documents ready and awaiting visa',
      success: 'Visa received',
      successHint: 'Visa received and departed',
      cancelled: 'Cancelled',
      ofTotal: '{p}% of all clients',
      pipeline: 'Client pipeline',
      pipelineHint: 'Click a stage to filter the list',
      directions: 'Directions',
      countries: 'Top countries',
      noData: 'No data',
      docsMissing: '{n} missing',
      docsComplete: 'All collected',
      docsMissingTitle: 'Missing documents:',
      stepOf: 'Stage {i} of {n}',
    },
  },

  travelPurpose: {
    work: 'Work',
    study: 'Study',
    tourism: 'Tourism',
    business: 'Business',
    other: 'Other',
  },

  direction: {
    ish: 'Work',
    oqish: 'Study',
    sayohat: 'Travel',
    biznes: 'Business',
    boshqa: 'Other',
  },

  clientStatus: {
    yangi: 'New',
    hujjat_yigilmoqda: 'Collecting documents',
    hujjatlar_tayyor: 'Documents ready',
    viza_kutilmoqda: 'Waiting for visa',
    viza_oldi: 'Visa received',
    jonatildi: 'Departed',
    bekor: 'Cancelled',
  },

  clientDetail: {
    qoshimchaTelefonlar: 'Additional phones',
    zagranHolati: 'Passport: clean / has stamps',
    zagranBelgilanmagan: 'Not marked',
    zagranToza: 'Clean (no stamps)',
    zagranPechatBor: 'Has stamps',
    readyToApply: 'Found in a document: {value} — click to write it into the field',
    readyHint: 'Green ones were already found in a document — click to apply ({n}).',
    factSource: { mrz: 'MRZ', ai: 'AI', ocr: 'OCR', text: 'text', pdf_form: 'form', manual: 'manual', anketa: 'form', xodim: 'staff', claude: 'Claude', hujjat: 'document', import: 'import' },
    factDocs: 'same in {n} documents',
    factConflict: 'Documents give {n} different values — pick the right one (amber tags)',
    factAlternative: '{source}: {value} — click to write this value',
    fieldSource: {
      confirm: 'Confirm',
      levels: { tasdiqlangan: 'verified', yuqori: 'high', orta: 'medium', past: 'low' },
      tooltip: '{source} · confidence: {level}',
      document: 'Document: {doc}',
      holat: {
        savatda: 'The source document is in the trash — restore it from "Trash" on the client card',
        ochirilgan: 'The source document was deleted permanently — the value stays as confirmed by staff',
      },
      belgi: { savatda: 'in trash', ochirilgan: 'source deleted' },
      confirmedBy: 'Confirmed by {who}',
      reviewHint: 'If correct, click ✓; if wrong, click the value and edit it',
      reviewTitle: 'Filled automatically — please review',
      reviewIntro: 'These values were written from documents automatically. If correct, click ✓; if wrong, edit them or pick another value from a document.',
      confirmed: '{n} field(s) confirmed',
      confirmHigh: 'Confirm high-confidence ({n})',
      alternative: 'Another value in a document: {value} ({source}) — click to use it',
      alternativesLabel: 'Other values:',
    },
    zagranPassport: 'Travel passport',
    nationalPassport: 'National passport / ID card',
    zagranSeriesHint: 'FA',
    nationalSeriesHint: 'AD',
    nationalNumberHint: 'AD2098993',
    notFoundYet: 'Not found yet',
    notFoundHint: 'Amber — expected from a document but not found. Grey — filled in by hand. Click to fill.',
    showFull: 'Show full details',
    hideFull: 'Hide full details',
    missing: 'Missing:',
    andMore: '+ {n} more',
    collection: 'Document collection',
    ifNeeded: 'if needed',
    // Account credentials (email, OneID) - password is encrypted
    credentials: 'Account credentials',
    credentialsHint: 'Passwords are stored encrypted. Every reveal is logged: who, when, which client.',
    credentialKeyMissing: 'Encryption key is not configured - password storage is disabled. An administrator must add CREDENTIAL_KEY to .env.',
    addCredential: 'Account',
    noCredentials: 'No credentials added',
    credentialKind: 'Type',
    credentialLogin: 'Login',
    credentialPassword: 'Password',
    credentialNote: 'Note',
    credentialLoginPrompt: 'Enter the login or email address',
    credentialLoginRequired: 'The login cannot be empty',
    deleteCredentialConfirm: 'The account {login} will be deleted. Continue?',
    credKindEmail: 'Email',
    credKindOneId: 'OneID',
    credKindMyGov: 'MyGov',
    credKindEmbassy: 'Embassy portal',
    credKindOther: 'Other',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    changePassword: 'Change password',
    noPassword: 'No password',
    passwordPrompt: 'New password for {login}',
    passwordPlaceholder: 'Leave empty to remove the password',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    // Personal data taken from documents (0019) and visa applications
    identityInfo: 'Personal details',
    middleName: 'Patronymic',
    gender: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    genderUnspecified: 'Unspecified',
    pinfl: 'PINFL',
    pinflHint: '14 digits',
    birthPlace: 'Place of birth',
    birthDistrict: 'District of birth',
    email: 'Email',
    passportSeries: 'Series',
    passportSeriesHint: 'AD',
    passportNumberHint: 'AD2098993',
    savedOk: 'Saved',
    applications: 'Visa applications',
    addApplication: 'Application',
    noApplications: 'No applications added',
    applicationNumber: 'Application number',
    applicationDate: 'Date',
    applicationCountry: 'Country',
    applicationVisaType: 'Visa type',
    applicationStatus: 'Status',
    applicationNumberPrompt: 'Enter the application number',
    applicationNumberRequired: 'The number cannot be empty',
    appStatusSubmitted: 'Submitted',
    appStatusWaiting: 'Waiting',
    appStatusAccepted: 'Approved',
    appStatusRejected: 'Rejected',
    deleteApplicationConfirm: 'Application {number} will be deleted. Continue?',
    title: 'Client Information',
    downloadAll: 'Download all',
    firstName: 'First name',
    lastName: 'Last name',
    dateOfBirth: 'Date of birth',
    passportNumber: 'Passport number',
    nationality: 'Nationality',
    issueDate: 'Issue date',
    expiryDate: 'Expiry date',
    issuedBy: 'Issuing authority',
    issuedByHint: 'e.g. MIA 26001 / IIV 26001',
    anketaData: {
      employerTitle: 'Current employer (country of residence) — form page 6/13',
      viewAll: 'All',
      formHint: 'Everything the application form asks, page by page. Red — missing: fill it in here and the form agent will not ask during the run.',
      progress: 'Required data: {tayyor} / {jami} ready',
      notNeeded: 'not needed',
      title: 'Application data',
      hint: 'Data collected for visa application forms (employer, address, trip). Click a value to edit — the form filler uses it next time.',
      refresh: 'Refresh',
      loadError: 'Application data failed to load — editing is disabled',
      conflict: 'The value changed meanwhile — reload the page and confirm again',
    },
    country: 'Country',
    travelPurpose: 'Travel purpose',
    direction: 'Direction',
    status: 'Status',
    jobTitle: 'Job title',
    employerName: 'Employer',
    phone: 'Phone',
    address: 'Address',
    notes: 'Notes',
    registeredBy: 'Registered by',
    updatedAt: 'Updated at',
    createdAt: 'Created at',
    createCv: 'Build CV',
    lastModifiedBy: 'Last modified by',
    passportImage: 'Passport image',
    universityName: 'University name',
    studyProgram: 'Study program',
    travelDates: 'Travel dates',
    hotelName: 'Hotel name',
    destinationCountry: 'Destination country',
    personalInfo: 'Personal information',
    directionInfo: 'Direction details',
    passportInfo: 'Passport information',
    passportOptional: 'Passport information (optional)',
    statusChanged: 'Status changed',
    statusChangeError: 'Error changing status',
    workDirection: 'Work',
    studyDirection: 'Study',
    travelDirection: 'Travel',
    businessDirection: 'Business',
    fullView: 'Full view',
    updateSuccess: 'Client information updated',
    updateError: 'Error updating information',
    notFound: 'Client not found',
    loadError: 'Client not found or loading error',
    noId: 'Client ID not found',
    documents: 'Documents',
    selectDocType: 'Select document type',
    selectFile: 'Select file',
    uploadHint: 'Allowed formats: PDF, JPG, PNG, GIF, DOC, DOCX, XLS, XLSX, PPT, PPTX, MP4, AVI, MOV (max 100MB)',
    uploadSuccess: 'Document uploaded successfully!',
    uploadError: 'Error uploading document',
    noDocuments: 'No documents',
    confirmDeleteDoc: 'The document goes to the trash — its file and extracted data are kept and it can be restored. Reason (optional):',
    docDeleteSuccess: 'Document moved to trash — it can be restored',
    deleteDocSabab: 'E.g. uploaded by mistake, old version',
    savatgaTashlash: 'Move to trash',
    docDeleteError: 'Error deleting document',
    downloadError: 'Error downloading',
    fileSizeError: 'File size must not exceed 100MB',
    additionalNotes: 'Additional notes',
    showMore: 'Show more',
    showLess: 'Show less',
    moreFiles: 'more files',
    prevDoc: 'Previous',
    nextDoc: 'Next',
    previewNotAvailable: 'Preview is not available for this file type. Please download it.',
    videoNotSupported: 'Your browser does not support this video format',
    docs: {
      addMore: '+ Upload more',
      filesSelected: '{n} files selected',
      nUploaded: '{n} files uploaded',
      badFile: '{fayl}: this file type is not accepted',
      tooLarge: '{fayl}: larger than {mb} MB',
      multiHint: 'You can select or drop several files at once. PDF, JPG, PNG, DOC(X), XLS(X), PPT(X) — up to 50 MB. Videos (up to 300 MB) go to the «Video clip» section automatically',
      variantName: 'CV variant',
      variantPrompt: '{fayl} — what should this CV variant be called? (e.g. position and language)',
      variantPlaceholder: 'e.g. Welder — English',
      turniTasdiqla: 'Confirm type: {tur}',
      turTasdiqlangan: 'Type confirmed',
      topshiriladi: 'Submit',
      topshirilmaydi: 'Do not submit',
      topshirishYoq: 'Not marked',
      topshirishBelgila: 'Submit?',
      topshirishOlib: 'Remove the mark',
      topshirishHint: 'Does it go to the embassy? Click to mark',
      topshirishKim: 'Marked by {kim}, {vaqt}',
      topshirishFiltrHint: 'Documents that go into the embassy folder',
      topshirilmaydiSabab: 'Why is it not submitted? (optional)',
      topshirilmaydiMisol: 'e.g. for information only',
      izohUzun: 'Up to 300 characters',
      turTasdiqKim: 'Confirmed by {kim}, {vaqt}. Click to remove the confirmation',
      turTasdiqlandi: 'Document type confirmed — the application form now relies on it',
      turTasdiqOlindi: 'Type confirmation removed',
      nomTitle: 'Document name',
      nomPrompt: '{fayl} — what document is this? Enter its name: the file is saved under this name.',
      nomPromptQayta: 'Enter the document name: the file will be renamed.',
      nomPlaceholder: 'e.g. Military ID',
      nomBosh: 'Enter the document name',
      nomUzun: 'The name must be 200 characters or fewer',
      nomBer: 'Add name',
      nomOzgartir: 'Rename',
      nomSaqlandi: 'Name saved',
      faqatVideo: '{fayl}: only video files go to the «Video clip» section (mp4, mov ...)',
      videogaOtdi: '{n} video(s) uploaded to the «Video clip» section',
      videoOqilmaydi: 'Video — not read',
      filterAll: 'All',
      filterDone: 'Read',
      filterQueue: 'In queue',
      filterAttention: 'Needs attention',
      queueHint: 'Documents waiting in the queue or being read now',
      attentionHint: 'Unreadable, belonging to someone else / unknown owner, or only partly read',
      searchPlaceholder: 'Search by file name or type',
      dropTitle: 'Drop a file here',
      dropOr: 'or',
      dropBrowse: 'browse your computer',
      dropActive: 'Release to add the file',
      typeRequired: 'Choose the document type to upload',
      colDocument: 'Document',
      colStatus: 'Reading status',
      colUploaded: 'Uploaded',
      noMatch: 'No documents match this filter',
      resetFilter: 'Clear filter',
      showMoreN: 'Show {n} more',
    },
    // Document read status (OASIS / CEO PC)
    aylantir: {
      chapga: 'Rotate left',
      ongga: 'Rotate right',
      asl: 'Original',
      aslHint: 'Restore the document to its uploaded orientation (the original is kept)',
      saqlanmoqda: 'Saving…',
      ok: 'Document rotated',
      okAsl: 'Document restored to original',
      okQayta: 'Document rotated and sent for re-reading',
      xato: 'Could not rotate',
    },
    extraction: {
      orqaTomon: 'Back side?',
      orqaTomonHint: 'The ID card back side seems missing: PINFL and place of birth are printed there. Upload the back side too ("+ Add more").',
      mijozHozir: 'Read now',
      mijozHozirHint: 'This client is the priority: their documents go to the front of the queue. Unread and incomplete ones are re-read',
      mijozHozirOk: '{u} documents moved to the front, {q} sent for re-reading',
      mijozHozirNavbatda: 'Documents are already at the front of the queue ({n})',
      mijozHozirToliq: 'All documents are read and the required data is captured',
      agentShu: 'The document agent is reading this client now',
      agentBoshqa: 'The document agent is reading another client — this one is next',
      agentTayyor: 'The document agent is ready — it will start in a few seconds',
      agentUzilgan: 'The document agent has been offline for {m} min — check that its computer is on and online',
      agentYoq: 'The document agent is not connected — check that its computer is on',
      oqish: 'Let the document agent read it',
      oqishYorliq: 'Read',
      oqishOn: 'The agent will read it. Turn off to remove from the queue (read data is kept)',
      oqishOnForced: 'Turned on by staff: this type is not read by default, but it will be',
      oqishOff: 'Not read — turned off by staff. Turn on to queue it',
      oqishOffAuto: 'This type is not read by default (presence is enough). Turn on to read it',
      oqishYoqildi: 'Reading turned on',
      oqishOchirildi: 'Reading turned off — removed from the queue',
      hozir: 'Read now',
      hozirHint: 'Front of the queue — the agent reads it first in its next cycle',
      hozirOk: 'Moved to the front of the queue',
      orin: 'position {n}',
      // Writing a fact into a client field
      applyToField: 'Write into the client field',
      appliedTo: 'Written into {field}',
      notApplied: 'Not written',
      ownerFamily: 'Family member #{n}',
      ownerFamilyPlain: 'Family member',
      ownerForeign: 'Third party',
      ownerUnknown: 'Owner unknown',
      summary: 'Read {done}/{total}',
      summaryHint: 'Documents that OASIS (CEO PC) has read and added to the database',
      doneCount: 'Read · {n} facts',
      pending: 'Queued',
      processing: 'Reading',
      failed: 'Error',
      skipped: 'Not read',
      opusKutadi: 'Awaiting Opus review',
      opusKutadiHint: 'Handwritten document: not read by rules (OCR / MRZ) — the Opus reviewer reads it with quotes',
      opusOdam: 'Opus could not read it — needs a person',
      opusIshYoq: 'Opus read it — no work entries',
      unknown: 'No status',
      pendingHint: 'Not read yet — waiting in the CEO PC queue',
      processingHint: 'CEO PC is reading it now',
      failedHint: 'Could not be read: {error}',
      skippedHint: 'Data is not extracted from this document type',
      skippedReasonHint: 'Not read: {error}',
      unknownHint: 'Read status not recorded',
      factsTitle: 'Data extracted from the document',
      doneOf: 'Read · {olindi}/{jami}',
      expectedTitle: 'Expected data',
      notExtracted: 'Not extracted',
      humanReads: 'Entered by staff from the document',
      presenceOnly: 'No data is read from this document — having it in the database is enough',
      openFactsHint: 'Click to open the document side by side with the data read from it',
      noFacts: 'No data found in the document',
      notReadYet: 'The document has not been read yet',
      verified: 'Verified (MRZ / check digit)',
      unverified: 'Not verified — please check',
      loadError: 'Could not load the data',
      reprocess: 'Send for re-check',
      reprocessShort: 'Re-check',
      autoApplied: 'Written to the card automatically: {fields}',
      reprocessConfirm: 'The document will be checked again and the current extracted data will be removed. Reason (optional):',
      reprocessQueued: 'Document queued to be read again',
      reprocessError: 'Could not queue the document',
      reprocessPrompt: 'The document will be checked again. Reason (optional):',
      reprocessReasonPlaceholder: 'e.g. wrong surname',
      reviewInfo: 'Sent for re-check by {user}, {date}',
      foreignSummary: '{n} document(s) belong to someone else',
      foreignSummaryHint: 'These documents seem to belong to another person — check they were not uploaded by mistake',
      docOwnerForeign: "Someone else's",
      docOwnerUnknown: 'Owner unknown',
      docOwnerFamily: "Family member's",
    },

    firstNameRequired: 'Please enter first name',
    lastNameRequired: 'Please enter last name',
    passportRequired: 'Please enter passport number',
    birthDateRequired: 'Please select date of birth',
    issueDateRequired: 'Please select issue date',
    expiryDateRequired: 'Please select expiry date',
    countryRequired: 'Please enter country',
    phoneRequired: 'Please enter phone number',
    addressRequired: 'Please enter address',
    vacLinkedSuccess: '{count} vacancies linked',
    vacUnlinkedSuccess: 'Vacancy unlinked',
    employeesAssigned: 'Employees assigned',
    employeeAssigned: 'Employee assigned',
    assignCancelled: 'Assignment cancelled',
    fileTooLarge: 'File size must not exceed 100MB',
    errorGeneric: 'An error occurred',
  },

  docTypes: {
    oddiy_pasport: 'National passport',
    zagran_pasport: 'Travel passport',
    bank_schyot: 'Bank statement',
    ish_staji: 'Employer letter',
    ishxona_tarjima: 'Employer letter (translation)',
    mygov_digital: 'Digital information (my.gov)',
    mygov_family: 'Family information (my.gov)',
    mygov_yashash: 'Residence certificate (my.gov)',
    anketa: 'Application form',
    explanation_letter: 'Explanation letter',
    hotel_booking: 'Hotel booking',
    bron_bilet: 'Flight booking',
    priglosheniye: 'Invitation letter',
    diplom: 'Diploma',
    til_sertifikat: 'Language certificate',
    trip_plan: 'Trip plan',
    sudlanmaganlik: 'Police clearance',
    sudlanmaganlik_tarjima: 'Police clearance (translation)',
    mol_mulk: 'Property',
    mol_mulk_tarjima: 'Property (translation)',
    sugurta: 'Insurance',
    cv_photo: 'Photo',
    cv: 'CV',
    qoshimcha: 'Additional documents',
    video: 'Video clip',
    patent: 'Work patent (Russia)',
    nikoh_guvohnoma: 'Marriage certificate',
  },

  clientCreate: {
    title: 'Create new client',
    step1Title: 'Passport and basic info',
    whichRegion: 'Which region',
    whichCountry: 'Which country',
    selectCountryOptional: 'Select country (optional)',
    peopleCount: 'Number of people',
    uploadPassportText: 'Upload passport image <em>or drop it here</em>',
    uploadPassportTip: 'JPG/PNG format. OCR will auto-detect the data.',
    dividerBasic: 'Basic information',
    dividerPassport: 'Passport information',
    regionEurope: 'Europe',
    regionAsia: 'Asia',
    regionAmerica: 'America',
    regionOther: 'Other',
    person1: '1 person',
    person2: '2 people',
    personFamily: 'Family',
    personGroup: 'Group',
    personOther: 'Other',
    step2Title: 'Select direction',
    step3Title: 'Passport (optional)',
    step1: 'Upload passport',
    step2: 'Edit information',
    step3: 'Additional information',
    step4: 'Upload documents',
    firstName: 'First name',
    lastName: 'Last name',
    directionSelect: 'Select direction',
    saveWithoutPassport: 'Save without passport',
    universityName: 'University name',
    studyProgram: 'Study program',
    travelDates: 'Travel dates',
    hotelName: 'Hotel name',
    passportUploadDrag: 'Drop passport image here or',
    passportUploadClick: 'click',
    passportUploadHint: 'JPG, JPEG or PNG format, max 10MB',
    processOcr: 'Process (OCR)',
    ocrProcessing: 'OCR processing...',
    ocrDialogTitle: 'OCR Result',
    ocrExtractedData: 'Extracted data',
    ocrRawText: 'Raw text',
    ocrNoText: 'No text found',
    ocrClose: 'Close',
    ocrContinue: 'Continue',
    ocrSuccess: 'Passport processed successfully',
    ocrError: 'OCR processing error',
    ocrNotFound: 'Passport data not found',
    ocrParseError: 'Data parsing error',
    destinationCountry: 'Destination country',
    travelPurpose: 'Travel purpose',
    jobTitle: 'Job title',
    employerName: 'Employer name',
    phone: 'Phone',
    address: 'Address',
    additionalNotes: 'Additional notes',
    clientCreatedSuccess: 'Client created successfully!',
    uploadDocuments: 'Upload documents',
    done: 'Done',
    createError: 'Error creating client',
    firstNameRequired: 'Please enter first name',
    lastNameRequired: 'Please enter last name',
    passportRequired: 'Please enter passport number',
    birthDateRequired: 'Please select date of birth',
    issueDateRequired: 'Please select issue date',
    expiryDateRequired: 'Please select expiry date',
    countryRequired: 'Please enter country',
    phoneRequired: 'Please enter phone number',
    addressRequired: 'Please enter address',
    placeholderFirstName: 'e.g.: SHERZOD',
    placeholderLastName: 'e.g.: XOTAMOV',
    placeholderAddress: 'City, district',
    placeholderNotes: 'Additional notes...',
    placeholderCountry: 'e.g.: Germany',
    placeholderJobTitle: 'e.g.: Construction worker',
    placeholderEmployer: 'Company name',
    placeholderUniversity: 'University name',
    placeholderProgram: 'e.g.: IT, Medicine',
    placeholderTravelDates: 'e.g.: 15.06 - 30.06',
    placeholderHotel: 'Hotel name',
    placeholderPassportNumber: 'e.g.: AD2098993',
    placeholderPosition: 'Position or purpose',
    dividerWorkInfo: 'Work information',
    dividerStudyInfo: 'Study information',
    dividerTravelInfo: 'Travel information',
    dividerBusinessInfo: 'Business information',
    passportOptionalNote: 'You can create a client without a passport',
    ocrResultsTitle: 'OCR results',
    detectedData: 'Detected data',
    verifyImage: 'Verify against image',
    clickToEnlarge: 'Click to enlarge',
    applyOcr: 'Apply and fill',
    editIfWrong: '✎ Edit if incorrect',
    manualSection: 'Manual entry',
    manualSectionSub: 'These fields are not detected by OCR — filled in by the employee',
    duplicateTitle: 'Client already exists',
    duplicateMsg: 'A client with this passport number ({name}) is already registered. Open?',
    openExisting: 'Open',
    alreadyExistsShort: 'A client with this passport number already exists',
  },

  vacancies: {
    title: 'Vacancies',
    totalVacancies: 'Total vacancies',
    active: 'Active',
    closed: 'Closed',
    draft: 'Draft',
    searchPlaceholder: 'Vacancy, company, city...',
    jobType: 'Job type',
    experience: 'Experience',
    statusFilter: 'Status',
    newVacancy: 'New vacancy',
    editVacancy: 'Edit vacancy',
    vacancyName: 'Vacancy name',
    company: 'Company',
    city: 'City',
    country: 'Country',
    description: 'Description',
    salaryMin: 'Salary (min)',
    salaryMax: 'Salary (max)',
    currency: 'Currency',
    status: 'Status',
    deadline: 'Deadline',
    deadlineLabel: 'Deadline',
    fullTime: 'Full time',
    partTime: 'Part time',
    contract: 'Contract',
    temporary: 'Temporary',
    noExperience: 'No experience required',
    junior: 'Junior (0-2 years)',
    mid: 'Mid (2-5 years)',
    senior: 'Senior (5+ years)',
    draftStatus: 'Draft',
    activeStatus: 'Active',
    closedStatus: 'Closed',
    uzs: "So'm (UZS)",
    usd: 'Dollar (USD)',
    eur: 'Euro (EUR)',
    rub: 'Ruble (RUB)',
    confirmDelete: 'Do you want to delete this vacancy?',
    deleteSuccess: 'Vacancy deleted',
    updateSuccess: 'Vacancy updated',
    createSuccess: 'Vacancy created',
    formError: 'An error occurred',
    notFound: 'No vacancies found',
    nameRequired: 'Please enter vacancy name',
    companyRequired: 'Please enter company name',
    cityRequired: 'Please enter city',
    countryRequired: 'Please enter country',
    descriptionRequired: 'Please enter description',
    descriptionPlaceholder: 'Detailed vacancy description...',
  },

  scraped: {
    copyPhone: 'Copy number',
    phoneCopied: 'Copied: {phone}',
    copyFailed: 'Could not copy',
    bulkDeleteBtn: 'Delete',
    title: 'Scraped Vacancies',
    total: 'Total',
    unchecked: 'Unchecked',
    agency: 'Agency',
    direct: 'Direct',
    scammer: 'Scammer',
    allFilter: 'All',
    calledFilter: 'Called',
    categoryFilter: 'Category',
    noAnswer: 'No answer',
    callback: 'Requested callback',
    callError: 'Failed to update status',
    countryFilter: 'Country',
    siteFilter: 'Site',
    scrapeBtn: '1. Scrape',
    filterBtn: '2. Filter',
    detailBtn: '3. Detail',
    uploadBtn: '4. Upload',
    importJson: 'Import JSON',
    clearBtn: 'Clear',
    jobTitle: 'Title',
    postedDate: 'Date',
    country: 'Country',
    direction: 'Direction',
    phoneNumber: 'Phone',
    email: 'Email',
    phoneCall: 'Phone',
    category: 'Category',
    unassigned: 'Unassigned',
    remoteTag: 'Remote',
    expiredTag: 'Expired',
    partnerNew: 'Partner',
    partnerRegular: 'Regular',
    partnerPremium: 'VIP',
    ctAgency: 'Agency',
    ctDirect: 'Direct',
    ctScammer: 'Scammer',
    ctUnknown: 'Unknown',
    ctOpen: 'Open',
    dirWork: 'Work',
    dirStudy: 'Study',
    dirTravel: 'Travel',
    dirAvia: 'Avia',
    subWarehouse: 'Warehouse',
    subFactory: 'Factory',
    subFarm: 'Farm',
    subBuild: 'Construction',
    subIt: 'IT',
    subOther: 'General',
    expired: 'Expired',
    selectEmployees: 'Select employees',
    removeAssignees: 'Remove employees',
    assignBtn: 'Assign',
    makeOpen: 'Make open',
    viewOnlyBanner: 'This vacancy is assigned to {name}. View-only mode.',
    contactLabel: 'Contact',
    phoneLabel: 'Phone',
    phonesLabel: 'Phones',
    emailLabel: 'Email',
    emailsLabel: 'Emails',
    telegramLabel: 'Telegram',
    whatsappLabel: 'WhatsApp',
    openSource: 'Open source',
    newVacanciesAlert: '{n} new vacancies from this company!',
    otherVacancies: 'Other vacancies from this contact ({n})',
    newTag: 'NEW',
    callsCount: '{n} calls',
    callBtn: 'Call',
    emailBtn: 'Email',
    callAnswered: 'Answered',
    callNoAnswer: 'No answer',
    callCallback: 'Callback',
    writeNotePh: 'Write a note...',
    selectCategory: 'Select category',
    saveBtn: 'Save',
    filterAll2: 'All',
    filterCallback: 'Callback',
    searchByNotePh: 'Search by note...',
    noNoteWritten: 'No note written',
    noCallsYet: 'No calls yet',
    callsTab: 'Calls',
    linkedClientsTab: 'Linked clients',
    addClientBtn: '+ Add client',
    noLinkedClients: 'No linked clients',
    unlinkClient: 'Remove',
    selectClientDialog: 'Select client',
    clientSearchPh: 'Name, phone, passport...',
    refreshTip: 'Refresh',
    totalClients: 'Total: {n} · Shown: {m}',
    notFoundShort: 'Not found',
    noClientsYet: 'No clients yet',
    selectedSuffix: '{n} selected',
    cancelBtn: 'Cancel',
    linkBtn: 'Assign',
    ctDirect2: 'Employer',
    ctAgency2: 'Agency',
    ctScammer2: 'Scammer',
    ctUnknown2: 'Unknown',
    qnAnswered1: 'Spoke, provided info',
    qnAnswered2: 'Preparing documents',
    qnAnswered3: 'Agreed, waiting',
    qnAnswered4: 'Contract discussed',
    qnAnswered5: 'Documents requested',
    qnAnswered6: 'Agreed on another time',
    qnNoAns1: "Didn't pick up",
    qnNoAns2: 'Number is outdated / not working',
    qnNoAns3: 'Number belongs to someone else',
    qnNoAns4: 'Phone off',
    qnNoAns5: 'Rejected the call',
    qnNoAns6: 'Out of network',
    qnCall1: 'Asked to call back later',
    qnCall2: 'Busy, asked to call back',
    qnCall3: "Can't talk now",
    qnCall4: 'On another line',
    qnCall5: 'Call back during work hours',
    qnCall6: 'Working with another agency',
    notFound: 'No vacancies found',
    process: 'Process',
    running: 'Running...',
    finished: 'Finished!',
    now: 'Now',
    stop: 'Stop',
    scrapeLabel: 'Scrape (9 sites)',
    filterLabel: 'Filter (by keyword)',
    detailLabel: 'Detail (get phone/email)',
    anotherRunning: 'Another process is running',
    scrapeError: 'Scrape failed to start',
    filterError: 'Filter failed to start',
    detailError: 'Detail failed to start',
    importSuccess: 'Import: {created} new, {skipped} duplicates',
    importError: 'Import error',
    clearConfirm: 'All uncalled jobs will be deleted. Called jobs will be kept.',
    clearTitle: 'Clear database',
    stopRequested: 'Stop requested — process will end shortly',
    stopError: 'Error stopping process',
    saveError: 'Error saving',
    classifyError: 'An error occurred',
    callError: 'An error occurred',
    phonePlaceholder: '+371...',
    emailPlaceholder: 'email@...',
    filterAll: 'All',
    filterCalled: 'Called',
    filterAssigned: 'Assigned',
    filterRecall: 'Callback',
    directionPlaceholder: 'Direction',
    jobTypePlaceholder: 'Job type',
    detailsLoadError: 'Failed to load details',
    errorGeneric: 'An error occurred',
    vacancyReopened: 'Vacancy reopened',
    noteSaved: 'Note saved',
    noteError: 'Failed to save note',
    callLogError: 'Failed to log call',
    partnerAlready: 'This vacancy is already in the partners list',
    saved: 'Saved',
    clientUnlinked: 'Client unlinked',
    markedAsPartner: 'Marked as partner',
    selectTime: 'Select a time',
    scheduleAdded: 'Schedule added',
    deleted: 'Deleted',
  },

  users: {
    title: 'Employees',
    newEmployee: 'New employee',
    username: 'Username',
    fullName: 'Full name',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    status: 'Status',
    actions: 'Actions',
    editTitle: 'Edit employee',
    createTitle: 'New employee',
    firstName: 'First name',
    lastName: 'Last name',
    password: 'Password',
    roleAdmin: 'Admin',
    roleEmployee: 'Employee',
    activeStatus: 'Active',
    inactiveStatus: 'Inactive',
    editSuccess: 'Employee updated',
    createSuccess: 'Employee created',
    saveError: 'Error saving',
    loadError: 'Error loading data',
    usernameRequired: 'Please enter username',
    emailRequired: 'Please enter email',
    firstNameRequired: 'Please enter first name',
    lastNameRequired: 'Please enter last name',
    passwordRequired: 'Please enter password',
    passwordMinLength: 'Password must be at least 6 characters',
    resetPassword: 'Reset password',
    resetPasswordTitle: 'Reset password',
    resetPasswordHint: 'Set a new password (old password is not required)',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPasswordPlaceholder: 'Re-enter password',
    newPasswordRequired: 'Please enter new password',
    confirmPasswordRequired: 'Please confirm password',
    passwordsNotMatch: 'Passwords do not match',
    resetPasswordSuccess: 'Password reset successfully!',
    resetPasswordError: 'Error resetting password',
  },

  profile: {
    title: 'Profile',
    username: 'Username',
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    role: 'Role',
    roleAdmin: 'Admin',
    roleEmployee: 'Employee',
    changePassword: 'Change password',
    changePasswordTitle: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    passwordsNotMatch: 'Passwords do not match',
    oldPasswordRequired: 'Please enter old password',
    newPasswordRequired: 'Please enter new password',
    newPasswordMinLength: 'At least 6 characters',
    confirmPasswordRequired: 'Please confirm password',
    passwordChanged: 'Password changed successfully',
    adminResetHint: 'As admin, you can change password without the old one',
    passwordChangeError: 'Error changing password',
    uploadAvatar: 'Upload photo',
    uploadAvatarSuccess: 'Photo uploaded successfully',
    uploadAvatarError: 'Error uploading photo',
    avatarSizeError: 'Photo size must not exceed 20MB',
    editProfile: 'Edit profile',
    saveProfile: 'Save',
    editSuccess: 'Profile saved',
    editError: 'Error saving profile',
  },

  settings: {
    title: 'Settings',
    basePath: 'File storage path',
    basePathPlaceholder: 'E.g.: /home/user/crm_files',
    save: 'Save',
    hint: 'Client documents will be saved to this path. If empty, MEDIA_ROOT will be used.',
    currentStructure: 'Current structure',
    noSetting: 'No setting configured (default MEDIA_ROOT)',
    pathRequired: 'Please enter path',
    saveSuccess: 'Setting saved',
    saveError: 'Error saving',
  },

  cvBuilder: {
    title: 'CV Builder',
    back: 'Back',
    cvBuild: 'CV Build',
    jobDetails: 'Job Details',
    layoutSubtitle: 'Choose the CV layout structure',
    layout: 'Layout',
    templateSubtitle: 'Choose the CV color scheme',
    template: 'Color Theme',
    jobDetailPlaceholder: 'Paste the job description here: title, company, country, requirements...',
    selectClient: 'Select Client',
    searchClient: 'Search client...',
    clientSearchResults: '{count} results found',
    clientPageInfo: '{from}–{to} of {total}',
    fullName: 'Full Name',
    passport: 'Passport',
    country: 'Country',
    phone: 'Phone',
    selectedClient: 'Selected client',
    buildCv: 'Build CV',
    description: 'Description',
    sourceLink: 'Source link',
    noJob: 'Job not found',
    buildSuccess: 'CV created successfully!',
    buildError: 'Error creating CV',
    loadError: 'Error loading data',
    jobTitle: 'Job Title',
    company: 'Company',
    city: 'City',
    salary: 'Salary',
    language: 'CV Language',
    jobTitlePlaceholder: 'E.g.: Cook, Builder...',
    companyPlaceholder: 'Company name',
    countryPlaceholder: 'E.g.: Germany',
    cityPlaceholder: 'E.g.: Berlin',
    salaryPlaceholder: 'E.g.: 1500 EUR',
    descriptionPlaceholder: 'Job description...',
    previewHint: 'Click any text to edit. Click the photo to open zoom / pan controls. All changes are preserved in PDF.',
    saveAsPdf: 'Save as PDF',
    saveAsDocx: 'Save as Word (DOCX)',
    saveFormatTitle: 'Which format to save?',
    saveFormatPdfDesc: 'Preserves your edits, professional look',
    saveFormatDocxDesc: 'Original Word file, without edits',
    recommended: 'Recommended',
    previewTitle: 'CV Preview',
    save: 'Save',
    discard: 'Discard',
    discarded: 'CV discarded',
    prompts: 'Prompts',
    newPrompt: 'New Prompt',
    editPrompt: 'Edit Prompt',
    promptName: 'Prompt Name',
    promptNamePlaceholder: 'e.g. Standard CV prompt',
    promptContent: 'Prompt Text',
    promptChars: '{count} characters',
    promptContentPlaceholder: 'Write instructions for CV generation...',
    noPrompts: 'No prompts added yet',
    promptRequired: 'Name and text are required',
    promptCreated: 'Prompt created',
    promptUpdated: 'Prompt updated',
    promptDeleted: 'Prompt deleted',
    promptSaveError: 'Error saving prompt',
    promptDeleteError: 'Error deleting prompt',
    photoTitle: 'CV Photo',
    uploadPhoto: 'Upload photo',
    photoUploaded: 'Photo uploaded (for this CV)',
    photoFromClient: 'Photo from client profile will be used',
    photoNone: 'No photo',
    photoInvalid: 'Only image files are supported',
    photoWarnForLayout: 'Selected template is designed for a photo. Upload one for best results.',
    reviewTitle: 'Review and confirm CV data',
    reviewHint: 'Carefully review AI-generated data. Edit if needed. After confirmation, PDF will be generated.',
    professionalTitle: 'Professional Title',
    summary: 'Professional Summary',
    experience: 'Work Experience',
    position: 'Position',
    employer: 'Employer (company)',
    period: 'Period',
    periodPlaceholder: 'e.g. September 2018 – June 2021',
    description: 'Description',
    institution: 'Institution',
    specialization: 'Specialization / Degree',
    addExp: 'Add experience',
    addEdu: 'Add education',
    addSkill: 'Add skill',
    addLanguage: 'Add language',
    confirmAndGeneratePdf: 'Confirm and generate PDF',
    note: 'Note',
    education: 'Education',
    skills: 'Skills',
    languages: 'Languages',
    enhanceWithAI: 'Enhance with AI',
    photoEnhanced: 'Photo enhanced by AI',
    clearVacancy: 'Clear',
    vacancySearchPlaceholder: 'Search vacancy (title, country, company)...',
    layoutModernPhoto: 'Modern',
    layoutBadgeSidebar: 'Badge Sidebar',
    layoutTopHeader: 'Top Header',
    layoutSidebarLeft: 'Left Sidebar',
    layoutSidebarRight: 'Right Sidebar',
    layoutClassic: 'Classic',
    imgZoomOut: 'Zoom out',
    imgZoomIn: 'Zoom in',
    imgPanLeft: 'Left',
    imgPanUp: 'Up',
    imgPanDown: 'Down',
    imgPanRight: 'Right',
    imgReset: 'Reset',
    imgClose: 'Close',
    aiFallbackWithError: 'AI fallback was used: {error}',
    aiFallbackPlain: 'AI failed — a plain CV was created instead',
    buildTimeout: 'CV generation timed out. Please try again.',
    docxEditsLostWarning: 'The Word file is saved in its original state, without your edits. Choose PDF to preserve your edits.',
    clientAutoSelected: 'Client auto-selected: {name}',
    clientLoadFailed: 'Client could not be loaded — select one manually',
  },

  telefonlar: {
    qoshish: '+ Add number',
    tahrirlash: 'Edit',
    raqam_qoshish: 'Add number',
    raqam: 'Number',
    namuna: '+998 90 123 45 67',
    olib_tashlash: 'Remove',
    maks: 'At most {n} additional numbers',
    nusxa: 'Copy',
    nusxalandi: 'Copied',
  },
  educationEditor: {
    kiritilmagan: 'No education entered',
    qoshish: '+ Add education',
    tahrirlash: 'Edit',
    label: 'Education',
    institutionLabel: 'Institution',
    institutionPlaceholder: 'E.g. Tashkent State Technical University',
    specializationLabel: 'Specialization / Major',
    specializationPlaceholder: 'E.g. Electrical Engineering',
    fromYear: 'From year',
    toYear: 'To year',
    present: 'Present',
    addMore: 'Add another institution',
    hint: 'Optional. Entered education is preserved in the CV. If empty, AI will generate it.',
    empty: 'No institutions added — AI will generate education.',
  },

  workExperience: {
    label: 'Work experience',
    placeLabel: 'Place of work',
    placePlaceholder: 'E.g. Tashkent Tractor Plant (TTZ)',
    positionLabel: 'Position',
    positionPlaceholder: 'E.g. Welder, Plumber, Driver, Electrician...',
    fromYear: 'From year',
    toYear: 'To year',
    present: 'Present',
    addMore: 'Add another workplace',
    hint: 'Optional. Entered places are preserved in the CV. AI fills remaining years and enriches them.',
    empty: 'No workplaces added — AI will generate full experience on its own.',
    errorFromGreater: 'Start year cannot be later than end year',
  },

  languageSelector: {
    label: 'Spoken languages',
    languagePlaceholder: 'Language',
    levelPlaceholder: 'Level',
    addMore: 'Add another language',
    hint: 'Will appear in this order on the CV. Example: {example}',
    groupNative: 'Native',
    groupCefr: 'CEFR levels',
    groupFree: 'Free-form',
    native: 'Native speaker',
    a1: 'A1 — Beginner',
    a2: 'A2 — Elementary',
    b1: 'B1 — Intermediate',
    b2: 'B2 — Upper-intermediate',
    c1: 'C1 — Advanced',
    c2: 'C2 — Proficient',
    conversational: 'Conversational',
    confident: 'Confident',
    fluent: 'Fluent',
    langs: {
      uzbek: 'Uzbek',
      russian: 'Russian',
      english: 'English',
      korean: 'Korean',
      turkish: 'Turkish',
      german: 'German',
      french: 'French',
      italian: 'Italian',
      spanish: 'Spanish',
      arabic: 'Arabic',
      chinese: 'Chinese',
      japanese: 'Japanese',
      polish: 'Polish',
      czech: 'Czech',
      kazakh: 'Kazakh',
      kyrgyz: 'Kyrgyz',
      tajik: 'Tajik',
      persian: 'Persian (Dari)',
      ukrainian: 'Ukrainian',
      turkmen: 'Turkmen',
    },
  },

  botSurveys: {
    title: 'Bot Survey Submissions',
    searchPlaceholder: 'Name, phone, telegram...',
    fullName: 'Full Name',
    phone: 'Phone',
    purpose: 'Purpose',
    destination: 'Country',
    telegram: 'Telegram',
    date: 'Date',
    actions: 'Actions',
    view: 'View',
    delete: 'Delete',
    confirmDelete: 'Do you want to delete this survey?',
    confirmDeleteTitle: 'Confirm',
    deleteSuccess: 'Survey deleted',
    detailTitle: 'Survey Details',
    dob: 'Date of Birth',
    timeline: 'Departure Timeline',
    education: 'Education',
    specialty: 'Specialty',
    workExp: 'Work Experience',
    intlExp: 'International Experience',
    languages: 'Languages',
    criminal: 'Criminal Record',
    visa: 'Visa Rejections',
    travelBan: 'Travel Ban',
    marital: 'Marital Status',
    jobInterest: 'Job Interest',
    profession: 'Desired Profession',
    wishes: 'Personal Wishes',
  },

  network: {
    serverError: 'Server connection error',
    forbidden: 'Access denied',
    offline: 'No connection — will refresh automatically',
    slow: 'Slow connection, retrying...',
  },

  email: {
    dialogTitle: 'Send email to selected vacancies',
    senderLabel: 'Send from which email?',
    customSender: 'Enter manually',
    customEmailPh: 'your@email.com',
    customPassPh: 'Gmail App Password',
    saveSender: 'Save for next time',
    appPasswordHint: 'Obtain from Gmail > Security > 2FA > App Passwords',
    templateLabel: 'Template',
    selectTemplate: 'Select a template (optional)',
    saveAsTemplate: 'Save as template',
    deleteTemplate: 'Delete template',
    subjectLabel: 'Subject',
    subjectPh: 'e.g. Partnership proposal',
    bodyLabel: 'Body',
    bodyPh: 'Hello,\nWe are Oasis Visa agency...',
    recipientsLabel: 'Recipients',
    noEmail: 'no email',
    more: 'more',
    noEmailWarn: "{count} vacancies have no email — they'll be skipped",
    sendBtn: 'Send ({count})',
    sentAll: '{count} emails sent successfully',
    sentPartial: '{ok} sent, {fail} failed',
    sentFailed: 'Failed to send',
    templateNamePh: 'Template name',
    templateNameRequired: 'Enter a template name',
    templateSaved: 'Template saved',
    templateDeleted: 'Template deleted',
    confirmDeleteTpl: 'Delete this template?',
    subjectBodyRequired: 'Fill in subject and body first',
    markDefault: 'Mark as default template',
    bulkEmailBtn: 'Send email',
  },

  analytics: {
    myStatsTitle: 'My stats',
    employeesTitle: 'Employee monitoring',
    employeesSub: 'Who is online, what work has been done — in real time',
    day: 'Today',
    week: 'Week',
    month: 'Month',
    activeTime: 'Active time',
    realWorkTime: 'Real work time (excluding idle)',
    vacancies: 'Vacancies',
    partnersAdded: 'Partners added',
    partners: 'Partners',
    clientsWorked: 'Clients',
    clientsAssigned: 'New clients',
    stageChanged: 'Moved to next stage',
    completed: 'Completed',
    online: 'Online',
    onlineNow: 'Online now',
    lastSeen: 'Last active',
    totalHours: 'Total hours',
    employee: 'Employee',
    activity: 'Activity',
    roleAdmin: 'Administrator',
    roleEmployee: 'Employee',
    noEmployees: 'No employees found',
    neverLoggedIn: 'Never logged in',
    justNow: 'just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    lvlInactive: 'Inactive',
    lvlLow: 'Low',
    lvlMedium: 'Medium',
    lvlGood: 'Good',
    lvlHigh: 'High',
    lvlElite: 'Elite',
  },
  pwa: {
    title: "Install the app",
    desc: "Install it on your phone — it opens faster and works without the browser.",
    iosHint: "Tap “Share” below, then “Add to Home Screen”.",
    install: "Install",
    later: "Later",
  },
  dv: {
    title: "Green Card (DV) entries",
    subtitle: "Client DS-5501 entries kept as templates: when registration opens, the data, photo and passport scan are already checked and ready. Entries are submitted only on dvprogram.state.gov, with the client.",
    yangi: "New entry",
    qidirish: "Name, passport, phone, email or Confirmation Number",
    meniki: "Only mine",
    ta: "total",
    bosh: "No entries yet",
    ishtirokchi: "Entrant",
    ismsiz: "(no name)",
    telefon: "Phone",
    crmMijoz: "CRM client",
    tayyorlik: "Readiness",
    xato: "errors",
    xatosiz: "no errors",
    holati: "Status",
    oila: "Family",
    yangilangan: "Updated",
    crmdan: "From CRM client",
    boshAnketa: "Blank entry",
    mijozIzla: "Search by surname, name or passport",
    crmdanIzoh: "Name, birth date, passport, phone, email and address are filled from CRM — check each against the passport. The patronymic is not entered as Middle Name.",
    boshIzoh: "If the client is not in CRM yet, the entry can be linked to a client later.",
    ochish: "Open",
    holat: {
      qoralama: "Draft",
      tayyor: "Ready",
      topshirildi: "Submitted",
      yutdi: "Selected",
      yutmadi: "Not selected",
      bekor: "Cancelled"
    },
    royxat: "List",
    bekorQil: "Discard changes",
    saqlash: "Save",
    bekorQilish: "Cancel entry",
    tiklash: "Restore",
    ochirish: "Delete permanently",
    bekorQilingan: "The entry is cancelled — restore it first to edit (⋯ menu).",
    oilaAzolari: "Family members",
    keyingi: "Next",
    tekshirish: "Review",
    olibTashlash: "Remove",
    turmushQosh: "Add spouse",
    farzandQosh: "Add child",
    tuzatishKerak: "Needs fixing",
    xatoYoq: "No errors — the entry is ready for registration.",
    tekshiribKoring: "Please check",
    shpargalka: "Cheat sheet (official form order)",
    yangilash: "Refresh",
    nusxalash: "Copy",
    shpIzoh: "On registration day the form on dvprogram.state.gov is filled field by field from this text. Dates as on the form: MONTH / DAY / YEAR.",
    saqlanmagan: "There are unsaved changes — the cheat sheet shows the last saved state.",
    tayyor: "ready",
    topshirishgaTayyor: "Ready for registration",
    mijozBogla: "Link to a CRM client",
    topshirish: "Submission",
    topshirishIzoh: "The 16-character Confirmation Number shown after submitting on the official site — results are checked only with it.",
    raqamniYangila: "Update number",
    topshirildiDeb: "Mark as submitted",
    natija: "Result",
    kutilmoqda: "Pending",
    izoh: "Staff note",
    izohPh: "Not visible to the client",
    yaratgan: "Created",
    ozgartirgan: "Changed",
    saqlangan: "Saved",
    ozgarishYoq: "No changes — everything is saved",
    saqlanmaganQisqa: "Unsaved changes",
    saqlandi: "Saved",
    saqlandiTayyor: "Saved — the entry is ready for registration",
    xatoQoldi: "errors left"
  }
}
